import * as React from 'react';

const UserFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="user-fill_svg__eds-icon--user-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="user-fill_svg__eds-icon--user-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3 17.2c-.4.4-.9.8-1.4 1.2-.1.1-.4.3-.4.3-2.3 1.5-4.9 2.3-7.6 2.3-3.3 0-6.7-1.2-9.3-3.7l-.6.6C4.8 20.6 8.4 22 12 22s7.2-1.4 10-4.1l-.7-.7z"
        />
        <path
            id="user-fill_svg__eds-icon--user-fill_body"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.1 17.7c-1.4-2.6-4.1-4.2-7.2-4.2-3 0-5.7 1.7-7.1 4.2 4.3 2.9 10 2.9 14.3 0z"
        />
        <circle
            id="user-fill_svg__eds-icon--user-fill_head"
            fillRule="evenodd"
            clipRule="evenodd"
            cx={12}
            cy={7}
            r={5}
        />
    </svg>
);

UserFillSvg.displayName = 'UserFillSvg';
export default UserFillSvg;
